module.exports = __webpack_public_path__ + "media/images/bg/mosaic/cloud-5581071512b8f79b1b62c7410bd78f3f.svg";